IpixJson.options.jssocials = {
    showLabel: false,
    showCount: false,
    shares: [
        "facebook",
        "linkedin",
        {
            'share': 'whatsapp',
            'shareUrl': "https://api.whatsapp.com/send?text={url}"
        },
        {
            'share': 'twitter',
            'logo': 'fa-brands fa-x-twitter'
        },
    ],
};

window.IpixJson.jssocials = {};
